import { BuilderType, projectsCacheTags } from './projectsApiHelpers';

import { Client, DealersResponse } from '../types/Client';
import { makePaginationUrl } from '../../utils/utils';
import { PaginationParams } from '../types/common';
import {
  PROJECTS_RECEIVED_CREATE_CLIENT,
  PROJECTS_RECEIVED_GET_CLIENTS,
  PROJECTS_RECEIVED_UPDATE_CLIENT,
} from '../../legacy/actions/project-actions';
import { legacyFulfill } from '../utils';
import { ResponseOf } from '../../@types/api-utils';

export const providedTags = ['Client'];
export const clientAssociatedTags = [
  'Facilities',
  'Contacts',
  'Projects',
  'Addresses',
  'NewTeams',
  'NewTeamResources',
  'ClientOwner',
  'ClientInterfaces',
  'UserInterfaces',
  'UserDashboards',
  'CustomerGroups',
  'Notes',
  'NewTeam',
  'NewTeamResource',
];

export const fullClientTags = [
  projectsCacheTags.CLIENTS,
  projectsCacheTags.FACILITIES,
  projectsCacheTags.CONTACTS,
  projectsCacheTags.PROJECTS,
  projectsCacheTags.FACILITY_ADDRESSES,
  projectsCacheTags.NEW_TEAMS,
  projectsCacheTags.NEW_TEAM_RESOURCES,
  projectsCacheTags.CLIENT_OWNERS,
  projectsCacheTags.CLIENT_INTERFACES,
  projectsCacheTags.USER_INTERFACES,
  projectsCacheTags.USER_DASHBOARDS,
  projectsCacheTags.CUSTOMER_GROUPS,
  projectsCacheTags.NOTES,
  projectsCacheTags.VEHICLES,
];

export const clientsApi = (builder: BuilderType) => ({
  getClients: builder.query<Client, void>({
    query: () => `service/clients`,
    providesTags: fullClientTags,
    onQueryStarted: legacyFulfill(PROJECTS_RECEIVED_GET_CLIENTS),
  }),

  getClient: builder.query<Client, number>({
    query: (id) => `service/clients/${id}`,
    providesTags: fullClientTags,
  }),
  getClientByPortalId: builder.query<Client, string>({
    query: (portalId) => `service/clients/portal-id/${portalId}`,
    providesTags: fullClientTags,
  }),
  getClientsPaginated: builder.query<Client, PaginationParams>({
    query: (params) => makePaginationUrl(`service/clients-page`, params),
    providesTags: fullClientTags,
  }),
  createClient: builder.mutation<Client, Partial<Client>>({
    query: (body) => ({
      url: `service/clients`,
      method: 'POST',
      body,
    }),
    invalidatesTags: [projectsCacheTags.CLIENTS],
    onQueryStarted: legacyFulfill(PROJECTS_RECEIVED_CREATE_CLIENT),
  }),

  updateClient: builder.mutation<Client, Partial<Client>>({
    query: (body) => ({
      url: `service/clients/${body.id}`,
      method: 'PUT',
      body,
    }),
    invalidatesTags: [projectsCacheTags.CLIENTS],
    onQueryStarted: legacyFulfill(PROJECTS_RECEIVED_UPDATE_CLIENT),
  }),
  getClientsIds: builder.query<number[], void>({
    query: () => `service/clients-optimized`,
  }),
  getClientHomeAccount: builder.query<Client, number>({
    query: (id) => `service/clients/${id}/home-account`,
    providesTags: fullClientTags,
  }),
  getDealersPaginated: builder.query<Client, PaginationParams>({
    query: (params) => makePaginationUrl(`service/clients/dealers`, params),
    providesTags: fullClientTags,
  }),
  getClientParents: builder.query<Client[], number>({
    query: (id) => `service/clients/${id}/parents`,
    providesTags: fullClientTags,
  }),
  getClientChildren: builder.query<Client[], number>({
    query: (id) => `service/clients/${id}/children`,
    providesTags: fullClientTags,
  }),
  getDealers: builder.query<DealersResponse, void>({
    query: () => `service/clients/dealers`,
    providesTags: fullClientTags,
  }),
});
